import Fade from "react-reveal";
import { Container, Form } from "reactstrap";

import "rsuite/dist/rsuite.min.css";

// images
import CustomPagination from "Component/common/CustomPagination";
import SearchFilter from "Component/common/SearchFilter";
import TableActions from "Component/common/TableActions";
import TableLayout from "Component/common/TableLayout";
import TableProfile from "Component/common/TableLayout/TableProfile";
import dataHandler from "hooks/dataHandler";
import moment from "moment";
import {
  APP_INTRO_LIST,
  DELETE_APP_INTRO,
  FEEDBACK_LIST,
  MANAGE_APP_INTRO,
  MANAGE_USER,
} from "services/ApiCalls";
import ViewPopUp from "./View/ViewPopUp";
import { useState } from "react";
import { truncateString } from "utilities/utilities";
import TableStatusOptionsAction from "Component/common/TableStatusOptionsAction";
import { useNavigate } from "react-router-dom";
import Plussvg from "../../../assets/svg/plussvg.svg";
import { Button } from "react-bootstrap";
import DeleteModal from "./DeleteModal";
import usePermissions from "hooks/usePermissions";
import { PERMISSION_KEYS } from "utilities/permissionConst";

const AppIntro = () => {
  const navigate = useNavigate();
  const [viewModel, setViewModel] = useState({ show: false, data: null });
  const [deleting, setDeleting] = useState(false);
  const permission = usePermissions({
    permissionKey: PERMISSION_KEYS.APP_INTRO_PERMISSION,
  });
  const confirmDelete = async () => {
    if (!deleteModel.id) return;

    try {
      setDeleting(true);
      const res = await DELETE_APP_INTRO(deleteModel.id); // replace with your API call
      if (res?.status === 200) {
        refetch(); // refresh the table
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
      setDeleteModel({ show: false, id: null });
    }
  };
  const {
    body,
    deleteHandler,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    statusChangeHandler,
    total,
    loader,
    setBody,
    data,
    refetch,
  } = dataHandler({
    api: APP_INTRO_LIST,
    dataToSet: (data) => data?.data?.data,
    extraBody: {
      startDate: "",
      endDate: "",
    },
    dependencies: ["startDate", "endDate"],
  });

  const col = [
    // {
    //   head: "Image",
    //   accessor: "email",
    //   component: (item) => <TableProfile image={item?.userId?.profileImage} />,
    // },
    {
      head: "Description",
      accessor: "description",
      component: (item) => <>{truncateString(item?.description, 30)}</>,
    },
    {
      head: "Short Description",
      accessor: "short_description",
      component: (item) => <>{truncateString(item?.short_description, 30)}</>,
    },
    {
      head: "Media Type",
      accessor: "media_type",

      // component: (item) => <>{truncateString(item?.long_question, 30)}</>,
    },
  ];

  if (permission.isAdd) {
    col.push({
      head: "Status",
      accessor: "accountType",
      component: (item, index) => (
        <TableStatusOptionsAction
          onChange={(userStatus) => {
            statusChangeHandler(
              () =>
                MANAGE_APP_INTRO({
                  ...item,
                  _id: item?._id,
                  status: userStatus,
                }),
              index,
              "status",
              userStatus,
              true,
            );
          }}
          statusOptionArr={[
            { value: "inactive", label: "Inactive" },
            { value: "active", label: "Active" },
          ]}
          value={item?.status}
        />
      ),
    });
  }

  if (permission.isAdd || permission.isDelete || permission.isView) {
    col.push({
      head: "Action",
      accessor: "",
      component: (item) => (
        <>
          <TableActions
            permissionKey={PERMISSION_KEYS.APP_INTRO_PERMISSION}
            deleteHandler={() => setDeleteModel({ show: true, id: item._id })}
            viewLink={`/app-intro-view/${item?._id}`}
            editLink={`/edit-app-intro/${item?._id}`}
          />
        </>
      ),
    });
  }

  return (
    <Fade>
      <ViewPopUp model={viewModel} setModel={setViewModel} />
      <section className="dashboard_first comon_dashpad">
        <Form>
          <div className="comom_fillter_set text-start">
            <div className="resource_headwrap d-flex align-items-center justify-content-between">
              <h3 className="fillter_head">Manage App Intro</h3>
            </div>

            <div className="fillter_form_wrap d-flex align-items-center gap-3 justify-content-between mt-4">
              <div className="fillter_area d-flex">
                <div className="fillter_by d-flex align-items-center gap-3">
                  <h5>Filter by :</h5>
                  <div className="search_form d-flex align-items-center gap-3">
                    <SearchFilter body={body} setBody={setBody} />
                  </div>
                </div>
              </div>
              {permission.isAdd && (
                <div className="export_btn d-flex align-items-center  justify-content-end gap-3">
                  <Button
                    className="plussvg"
                    onClick={() => navigate("/add-app-intro")}
                  >
                    <img src={Plussvg} alt="" className="img-fluid" />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Form>

        <div className="user_tabbingset mt-5">
          <section className="tabbing_common">
            <div className="tab-frame user_frame">
              <div className="pending_user_content mt-4">
                <section className="Diagnosis_table com_table ">
                  <Container>
                    <TableLayout
                      data={data}
                      column={col}
                      loader={loader}
                      body={body}
                    />
                    <div className="pagination_list d-flex align-items-center gap-3 justify-content-end py-3">
                      <CustomPagination
                        total={total}
                        body={body}
                        setBody={setBody}
                        pageChangeHandler={paginationHandler}
                      />
                    </div>
                  </Container>
                </section>
              </div>
            </div>
          </section>
        </div>
      </section>
      <DeleteModal
        isOpen={deleteModel.show}
        toggle={() => setDeleteModel({ show: false, id: null })}
        onDelete={confirmDelete}
        title="Are you sure you want to delete this App Intro?"
        loading={deleting} // optional, if you add loader in modal
      />
    </Fade>
  );
};

export default AppIntro;
